import { MergeFormSection } from "components/MainSectionTemplate/types";
import TwitterLink from "components/TwitterLink";
import WebsiteLink from "components/Website/WebsiteLink";
import { ContactFormState } from "shared/utils/fieldsHelper/contactFields";
import React from "react";

export const socialSection = (
  existingContact: ContactFormState,
  sourceContact: ContactFormState,
  currentContact: ContactFormState,
  setCurrentContact: (contact: ContactFormState) => void
): MergeFormSection => ({
  key: "socialsSection",
  title: "Socials",
  fields: [{
    key: "twitter",
    label: RESX.Contact.Twitter,
    currentValue: currentContact.twitter,
    existingValue: existingContact.twitter,
    sourceValue: sourceContact.twitter,
    isEmpty: (value) => !value,
    render: (value) => <TwitterLink twitter={value} />,
    onSourceClick: () => setCurrentContact({ ...currentContact, twitter: sourceContact.twitter }),
    onExistingClick: () => setCurrentContact({ ...currentContact, twitter: existingContact.twitter }),
  }, {
    key: "website",
    label: RESX.GeneralLabels.Website,
    currentValue: currentContact.website,
    existingValue: existingContact.website,
    sourceValue: sourceContact.website,
    isEmpty: (value) => !value,
    render: (value) => <WebsiteLink website={value} />,
    onSourceClick: () => setCurrentContact({ ...currentContact, website: sourceContact.website }),
    onExistingClick: () => setCurrentContact({ ...currentContact, website: existingContact.website }),
  }, {
    key: "facebook",
    label: "Facebook",
    currentValue: currentContact.facebook,
    existingValue: existingContact.facebook,
    sourceValue: sourceContact.facebook,
    isEmpty: (value) => !value,
    render: (value) => <WebsiteLink website={value} />,
    onSourceClick: () => setCurrentContact({ ...currentContact, facebook: sourceContact.facebook }),
    onExistingClick: () => setCurrentContact({ ...currentContact, facebook: existingContact.facebook }),
  }, {
    key: "networkPath",
    label: RESX.Company.NetworkPath,
    currentValue: currentContact.networkPath,
    existingValue: existingContact.networkPath,
    sourceValue: sourceContact.networkPath,
    isEmpty: (value) => !value,
    render: (value) => <WebsiteLink website={value} />,
    onSourceClick: () => setCurrentContact({ ...currentContact, networkPath: sourceContact.networkPath }),
    onExistingClick: () => setCurrentContact({ ...currentContact, networkPath: existingContact.networkPath }),
  }]
});